import { BaseAction } from '../../store/actions';
import { ChatInfo, ChatMessage, PusherConnectOptions } from '../../shared/models/chat';

export enum ChatActions {
  PusherConnect = '[Chat] Pusher Connect',
  PusherConnectSuccess = '[Chat] Pusher Connect Success',
  PusherConnectFailed = '[Chat] Pusher Connect Failed',
  PusherDisconnect = '[Chat] Pusher Disconnect',
  SubscribeChannel = '[Chat] Subscribe Channel',
  UnsubscribeChannel = '[Chat] Unsubscribe Channel',
  MessageReceived = '[Chat] Message Received',
  LoadMessages = '[Chat] Load Messages',
  LoadMessagesSuccess = '[Chat] Load Messages Success',
  LoadMessagesFailed = '[Chat] Load Messages Failed',
  SendMessage = '[Chat] Send Message',
  SendMessageSuccess = '[Chat] Send Message Success',
  SendMessageFailed = '[Chat] Send Message Failed',
  ChatNewMessageUpdate = '[Chat] Chat New Message Update',
  ReadMessages = '[Chat] Read Messages',
  ReadAllChats = '[Chat] Read All Chats'
}

export class PusherConnect implements BaseAction<ChatActions> {
  readonly type = ChatActions.PusherConnect;

  constructor(public readonly payload: PusherConnectOptions) { }
}

export class PusherConnectSuccess implements BaseAction<ChatActions> {
  readonly type = ChatActions.PusherConnectSuccess;

  constructor(public readonly payload: any) { }
}

export class PusherConnectFailed implements BaseAction<ChatActions> {
  readonly type = ChatActions.PusherConnectFailed;

  constructor(public readonly payload: string) { }
}

export class PusherDisconnect implements BaseAction<ChatActions> {
  readonly type = ChatActions.PusherDisconnect;
}

export class SubscribeChannel implements BaseAction<ChatActions> {
  readonly type = ChatActions.SubscribeChannel;

  constructor(public readonly payload: {
    chat_channel: string,
    chatInfo: ChatInfo
  }) {}
}

export class UnsubscribeChannel implements BaseAction<ChatActions> {
  readonly type = ChatActions.UnsubscribeChannel;

  constructor(public readonly payload: string) {}
}

export class MessageReceived implements BaseAction<ChatActions> {
  readonly type = ChatActions.MessageReceived;

  constructor(public readonly payload: {
    chat_channel: string,
    message: ChatMessage
  }) {}
}

export class LoadMessages implements BaseAction<ChatActions> {
  readonly type = ChatActions.LoadMessages;

  constructor(public readonly payload: string) {}
}

export class LoadMessagesSuccess implements BaseAction<ChatActions> {
  readonly type = ChatActions.LoadMessagesSuccess;

  constructor(public readonly payload: {
    chat_channel: string,
    messages: ChatMessage[]
  }) {}
}

export class LoadMessagesFailed implements BaseAction<ChatActions> {
  readonly type = ChatActions.LoadMessagesFailed;

  constructor(public readonly payload: {
    error: string,
    chat_channel: string
  }) {}
}

export class SendMessage implements BaseAction<ChatActions> {
  readonly type = ChatActions.SendMessage;

  constructor(public readonly payload: {
    chat_channel: string,
    message: ChatMessage,
    invite_code: string
  }) {}
}

export class SendMessageSuccess implements BaseAction<ChatActions> {
  readonly type = ChatActions.SendMessageSuccess;

  constructor(public readonly payload: {
    chat_channel: string,
    message: ChatMessage
  }) {}
}

export class SendMessageFailed implements BaseAction<ChatActions> {
  readonly type = ChatActions.SendMessageFailed;

  constructor(public readonly payload: {
    error: string,
    chat_channel: string
  }) {}
}

export class ChatNewMessageUpdate implements BaseAction<ChatActions> {
  readonly type = ChatActions.ChatNewMessageUpdate;

  constructor(public readonly payload: {
    chat_channel: string,
    message: string
  }) {}
}

export class ReadMessages implements BaseAction<ChatActions> {
  readonly type = ChatActions.ReadMessages;

  constructor(public readonly payload: string) {}
}

export class ReadAllChats implements BaseAction<ChatActions> {
  readonly type = ChatActions.ReadAllChats;

}



export type ChatAction = PusherConnect | PusherConnectSuccess | PusherConnectFailed | PusherDisconnect
  | SubscribeChannel| UnsubscribeChannel | MessageReceived | LoadMessages | LoadMessagesSuccess | LoadMessagesFailed
  | SendMessage | SendMessageSuccess | SendMessageFailed | ChatNewMessageUpdate | ReadMessages | ReadAllChats;
